import axiosInstance from '@/api';
import {
  GetDlpProfileResponse,
  GetDlpProfilesResponse,
  SaveDlpProfileRequest,
  SaveDlpProfileResponse
} from '@/services/api/dlpSettingsApiArea/types';
import { DlpSettingsServiceType } from '@/services/api/dlpSettingsApiArea/interface';

export class DlpSettingsService implements DlpSettingsServiceType {
  async GetDlpProfiles(customerId?: number): Promise<GetDlpProfilesResponse> {
    try {
      const params = customerId !== undefined ? { customerId } : {};
      const { data } = await axiosInstance.get<GetDlpProfilesResponse>('v1/dlp-settings', {
        params
      });
      console.log('Raw API response:', data);
      console.log('Is array:', Array.isArray(data));
      if (Array.isArray(data)) {
        console.log('First profile:', data[0]);
      }
      return data;
    } catch (e) {
      throw new Error('Unable to fetch DLP profiles. Please try again later.');
    }
  }

  async GetDlpProfile(id: number): Promise<GetDlpProfileResponse> {
    try {
      const { data } = await axiosInstance.get<GetDlpProfileResponse>(`v1/dlp-settings/${id}`);

      return data;
    } catch (e) {
      throw new Error('Unable to fetch DLP profile. Please try again later.');
    }
  }

  async SaveDlpProfile(params: SaveDlpProfileRequest): Promise<SaveDlpProfileResponse> {
    try {
      const { data } = await axiosInstance.post<SaveDlpProfileResponse>('v1/dlp-settings', params);

      return data;
    } catch (e) {
      throw new Error('Unable to save DLP profile. Please try again later.');
    }
  }

  async DeleteDlpProfile(id: number): Promise<void> {
    try {
      console.log('DeleteDlpProfile called with:', id, 'type:', typeof id);
      const url = `v1/dlp-settings/${id}`;
      console.log('Delete URL:', url);
      await axiosInstance.delete(url);
    } catch (e) {
      throw new Error('Unable to delete DLP profile. Please try again later.');
    }
  }

  async ToggleEnabled(id: number, enabled: boolean): Promise<SaveDlpProfileResponse> {
    try {
      // Сначала получаем текущий профиль
      const profile = await this.GetDlpProfile(id);
      // Обновляем поле Enabled
      const updatedProfile = { ...profile, Enabled: enabled };
      // Сохраняем обновленный профиль
      const { data } = await axiosInstance.post<SaveDlpProfileResponse>(
        'v1/dlp-settings',
        updatedProfile
      );
      return data;
    } catch (e) {
      throw new Error('Unable to toggle DLP profile status. Please try again later.');
    }
  }
}
